import api from "@/services/api";

const _http = {
    async getAll() {
        try{
            const response = await api.get("/site");
            return response;
        } catch (error) {
            console.error("Site Service Error:", error.response?.data || error.message);
            throw error;
        }
        
    },
};




export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getAll(query);
      return {
        data: res.data.data.map((site) => site),
      };
    } catch (error) {
      console.error(
        "Site Controller Error:",
        error.response?.data || error.message,
      );

      return {
        data: [],
      };
    }
  },
};

